import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { CustomerTasks, CreateCustomerTask, UpdateCustomerTask } from "./pages";

export const CustomerTasksRouter = [
  <Route
    path="/customer-tasks"
    element={
      <ProtectedRoute roles={["Any"]}>
        <CustomerTasks />
      </ProtectedRoute>
    }
  />,

  <Route path="/customer-task">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateCustomerTask />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateCustomerTask />
        </ProtectedRoute>
      }
    />
  </Route>,
];
